import { toast } from 'sonner';

// LOT 47 · Z0 · un lien de téléchargement hors de la page ne télécharge rien (Safari, Firefox, fenêtres) : il est posé dans la page le temps du clic, puis « Téléchargé · {nom} »
export const installerTelechargements = () => {
  document.addEventListener('click', (ev) => {  // LOT 78 · capture : les liens posés dans la page
    const a = ev.target?.closest?.('a[download]');
    if (a && !a.dataset.z0) setTimeout(() => toast.success(`Téléchargé · ${a.download || 'fichier'}`, { id: `dl-${a.download}` }), 50);
  }, true);
  const clic = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function telecharger() {
    if (!this.hasAttribute('download')) return clic.call(this);
    if (this.isConnected) {  // LOT 78 · un export posé dans la page le dit aussi : « Téléchargé · nom »
      const r = clic.call(this);
      if (this.download && !this.dataset.z0) toast.success(`Téléchargé · ${this.download}`, { id: `dl-${this.download}` });
      return r;
    }
    this.style.display = 'none';
    document.body.appendChild(this);
    clic.call(this);
    setTimeout(() => this.remove(), 0);
    if (this.download) toast.success(`Téléchargé · ${this.download}`, { id: `dl-${this.download}` });
    return undefined;
  };
};

/* LOT 47 · 8 bis · un export = le fichier arrive tout de suite, avec son message ; une erreur le dit */
export const telecharger = async (url, nom) => {
  const { default: axios } = await import('axios');
  const id = toast.loading(`Préparation · ${nom}`);
  try {
    const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api${url}`, { withCredentials: true, responseType: 'blob' });
    const srv = r.headers?.['x-filename']; let fin = nom;  // LOT 47 · Z0 · le nom donné par le serveur (« {resto} · {quoi} · {période} · {date} »)
    try { if (srv) fin = decodeURIComponent(srv); } catch { /* nom local */ }
    const a = document.createElement('a');
    a.href = URL.createObjectURL(r.data); a.download = fin; a.dataset.z0 = '1';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    toast.success(`Téléchargé · ${fin}`, { id });
    return true;
  } catch (e) {  // la raison donnée par le serveur (« Ce mois n’est pas encore validé »), sinon le message général ; la fenêtre reste ouverte
    let msg = e?.response?.status === 402 ? 'Crédits insuffisants pour l’export.' : 'Export impossible.';
    try { const j = JSON.parse(await e.response.data.text()); const d = j.detail; msg = (typeof d === 'string' ? d : d?.texte || d?.message || d?.titre) || msg; } catch { /* message général */ }
    toast.error(`${msg} Rien n’a été débité.`, { id });
    return false;
  }
};
